// extracted by mini-css-extract-plugin
module.exports = {"auctionTimerWrapper":"_1TYUr"};